import { render, staticRenderFns } from "./VerifileTelegramUser.vue?vue&type=template&id=3adce5c6&scoped=true"
import script from "./VerifileTelegramUser.vue?vue&type=script&lang=js"
export * from "./VerifileTelegramUser.vue?vue&type=script&lang=js"
import style0 from "./VerifileTelegramUser.vue?vue&type=style&index=0&id=3adce5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adce5c6",
  null
  
)

export default component.exports